import { useMemo } from 'react';

import { useSession } from 'src/app/shared/hooks/session';

export type UserLocation = { city: string | null; stateCode: string | null; countryCode: string | null };
type Result = UserLocation | null;

export function useUserLocation(): Result {
	const session = useSession();

	const hasFullUserLocation = !!(session.user && (session.user.city || session.user.stateCode));
	const hasFullUserGeoipLocation = !!(session.geoipData.city || session.geoipData.region);
	// get user's location
	const userLocation = useMemo(() => {
		if (hasFullUserLocation) {
			const { user } = session;
			return { city: user.city, stateCode: user.stateCode, countryCode: user.country?.countryCode ?? null };
		}

		if (hasFullUserGeoipLocation) {
			const { geoipData } = session;
			return { city: geoipData.city, stateCode: geoipData.region, countryCode: geoipData.countryCode };
		}

		return null;
	}, [hasFullUserGeoipLocation, hasFullUserLocation, session]);

	return userLocation;
}
